export const getIdeaEvaluations = (id) => (dispatch, getState, { api }) => {
  return api.get(`/private/ideaEvaluation/idea/${id}`);
}

export const getCanEvaluateIdea = (id) => (dispatch, getState, { api }) => {
  return api.get(`/private/ideaEvaluation/idea/${id}/canEvaluate`);
}
